import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd, articleJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";

const faqs = [
  { q: "Var hittar jag alkohollagen?", a: "Alkohollagen (2010:1622) finns på riksdagen.se. Folkhälsomyndigheten publicerar också vägledningar." },
  { q: "Vilka områden är vanligast på provet?", a: "Ålderskontroll, ordning och nykterhet, serveringsansvar och marknadsföring återkommer ofta." },
];

export const Route = createFileRoute("/alkohollagen-fragor")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "Frågor om alkohollagen" },
      ]}
      title="Frågor om alkohollagen – träna inför provet"
      intro="Träna på frågor från hela alkohollagen – ålderskontroll, marknadsföring, ordning, tillsyn och mer."
      sections={[
        { h2: "Översikt av alkohollagen", body: "Alkohollagen reglerar tillverkning, försäljning, servering och marknadsföring av alkoholdrycker i Sverige. För dig som söker serveringstillstånd är kapitlen om servering, tillsyn och ansvar centrala." },
        { h2: "Vanliga frågetyper", body: "Frågor om åldersgränser, serveringstider, vad som räknas som matservering, ansvar för ordning, marknadsföringsregler och hantering av påverkade gäster." },
        { h2: "Tips för att lyckas", body: "Läs lagtexten översiktligt, träna kontinuerligt med Alkoholprovet och fokusera på områden där du presterar sämst." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
          { to: "/ovningsprov-serveringstillstand", label: "Övningsprov" },
          { to: "/alkohollagen-kapitel-3", label: "Alkohollagen kapitel 3" },
          { to: "/alkohollagen-kapitel-8", label: "Alkohollagen kapitel 8" },
          { to: "/serveringstillstand", label: "Serveringstillstånd" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/foretag", label: "Företagslösning" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Frågor alkohollagen 2026 – träna på provfrågor online" },
      { name: "description", content: "Träna på frågor inom alkohollagen inför kunskapsprovet. Alla områden, uppdaterat för 2026." },
      { property: "og:title", content: "Frågor alkohollagen 2026 – träna på provfrågor online" },
      { property: "og:description", content: "Träna provfrågor från hela alkohollagen – ålderskontroll, marknadsföring, ordning och tillsyn. Uppdaterat för 2026." },
      { property: "og:url", content: "https://alkoholprovet.se/alkohollagen-fragor" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/alkohollagen-fragor" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "Frågor om alkohollagen", url: "https://alkoholprovet.se/alkohollagen-fragor" },
      ]),
      articleJsonLd({
        url: "https://alkoholprovet.se/alkohollagen-fragor",
        headline: "Frågor alkohollagen 2026 – träna på provfrågor online",
        description: "Träna på frågor inom alkohollagen inför kunskapsprovet. Alla områden, uppdaterat för 2026.",
        datePublished: "2026-01-15",
        dateModified: "2026-06-10",
      }),
    ],
  }),
});
